import { DefaultOptions, QueryClient } from '@tanstack/react-query';
import { defaultQueryOptions } from './defaultOptions';

export function createQueryClient(overrides?: Partial<DefaultOptions>) {
  return new QueryClient({
    defaultOptions: { ...defaultQueryOptions, ...overrides },
  });
}

export const queryClient = createQueryClient();
